import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Hidden, Visible } from '@leroy-merlin-br/backyard-react-ui'

import HeaderProviderMethods from 'reactSite/Header/providers/HeaderProviderMethods'

import RenderDesktop from './components/DropdownMenu/DesktopMenu/components/RenderDesktop'
import RenderMobile from './components/DropdownMenu/MobileMenu/components/RenderMobile'

const Header = props => {
  const headerClass = classnames(
    'new-header',
    { 'is-black-weekend': props.isBlackWeekend }
  )

  return (
    <div className={headerClass}>
      <HeaderProviderMethods assistedSalesLinks={props.assistedSalesLinks} isBlackWeekend={props.isBlackWeekend}>
        <Visible giga tera>
          <RenderDesktop {...props} />
        </Visible>

        <Hidden giga tera>
          <RenderMobile {...props} />
        </Hidden>
      </HeaderProviderMethods>
    </div>
  )
}

Header.propTypes = {
  props: PropTypes.shape({
    isAssistedSale: PropTypes.bool,
    isBlackWeekend: PropTypes.bool
  })
}

export default Header
